import { render, staticRenderFns } from "./BaseStaffInfoBlock.vue?vue&type=template&id=19b45053&"
import script from "./BaseStaffInfoBlock.vue?vue&type=script&lang=js&"
export * from "./BaseStaffInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports